import { ElementType, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { ConversationsView } from "@my-helpers/common";
import { Box, Typography } from "@mui/material";
import DeleteConversation from "./Delete";
import { SummaryDetail, SummaryFooter, SummaryInfo, SummaryItem } from "../SummaryItem";
import { Button } from "../Button"
import DeleteIcon from '@mui/icons-material/Delete';
import { Stack } from "@mui/material";
import { formatDate } from "@/utils/dateHelpers";

interface ConversationListProps {
    conversations: ConversationsView;
    deleteConversation: (id: string) => Promise<boolean>;
}

const ConversationsList: ElementType<ConversationListProps> =
    ({ conversations, deleteConversation }) => {
        const navigate = useNavigate();
        const [deleting, setDeleting] = useState<string | null>(null);

        const handleDelete = (e: React.MouseEvent, conversationId: string) => {
            e.stopPropagation();
            setDeleting(conversationId);
        };

        return (
            <Box sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center'
            }}>
                <Stack width="80%">
                    {conversations.map((conversation) => (
                        <SummaryItem light={false}>
                            <SummaryInfo>
                                <Typography onClick={() => navigate(`/${conversation.id}`)}>
                                    {conversation.topic}
                                </Typography>
                            </SummaryInfo>
                            <SummaryFooter paddingY={0.6}>
                                <SummaryDetail>
                                    <span style={{ margin: '0 2px 0 0' }}>With:</span>
                                    <Link to={`/helpers/${conversation.participant_id}`}>
                                        {conversation.participant_name}
                                    </Link>
                                    <span style={{ margin: '0 4px' }}>•</span>
                                    Created: {formatDate(conversation.created_at)}
                                    <span style={{ margin: '0 4px' }}>•</span>
                                    Updated: {formatDate(conversation.updated_at)}
                                </SummaryDetail>
                                <Button
                                    variant="error"
                                    size="custom"
                                    customSize="1rem"
                                    icon={<DeleteIcon />}
                                    tooltip="Delete item"
                                    onClick={(e) => handleDelete(e, conversation.id)}
                                />
                            </SummaryFooter> 
                        </SummaryItem>
                    ))}
                </Stack>
                {deleting && (
                    <DeleteConversation
                        deleteConversation={deleteConversation}
                        deleting={deleting}
                        setDeleting={setDeleting}
                    />
                )}
            </Box>
        )
    }

export default ConversationsList;
